function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_177_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_331_",
  d: "M446.226,0h-386C27.017,0,0,27.017,0,60.226v386c0,33.209,27.017,60.226,60.226,60.226h386   c33.209,0,60.226-27.017,60.226-60.226v-386C506.452,27.017,479.435,0,446.226,0z M476.452,446.226   c0,16.667-13.56,30.226-30.226,30.226h-386C43.56,476.452,30,462.893,30,446.226v-386C30,43.56,43.56,30,60.226,30h386   c16.666,0,30.226,13.56,30.226,30.226V446.226z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_335_",
  d: "M253.226,55.586c-108.979,0-197.64,88.661-197.64,197.64s88.661,197.64,197.64,197.64   s197.64-88.661,197.64-197.64S362.205,55.586,253.226,55.586z M268.226,420.188V409.56c0-8.284-6.716-15-15-15s-15,6.716-15,15   v10.628c-85.435-7.613-152.64-79.58-152.64-166.961s67.205-159.349,152.64-166.961v10.628c0,8.284,6.716,15,15,15s15-6.716,15-15   V86.265c85.435,7.613,152.64,79.58,152.64,166.961S353.661,412.575,268.226,420.188z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_338_",
  d: "M274.833,231.62c-5.857-5.858-15.355-5.858-21.213,0l-0.394,0.394l-0.394-0.394   c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l0.394,0.394l-0.394,0.394   c-5.858,5.858-5.858,15.355,0,21.213c2.929,2.929,6.768,4.394,10.606,4.394s7.678-1.464,10.606-4.394l0.394-0.394l0.394,0.394   c2.929,2.929,6.768,4.394,10.606,4.394s7.678-1.464,10.606-4.394c5.858-5.858,5.858-15.355,0-21.213l-0.394-0.394l0.394-0.394   C280.691,246.975,280.691,237.478,274.833,231.62z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_341_",
  d: "M161.937,214.226c-21.505,0-39,17.495-39,39s17.495,39,39,39s39-17.495,39-39   S183.442,214.226,161.937,214.226z M161.937,262.226c-4.963,0-9-4.038-9-9s4.037-9,9-9s9,4.038,9,9S166.9,262.226,161.937,262.226z   "
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_346_",
  d: "M305.515,253.226c0,21.505,17.495,39,39,39s39-17.495,39-39s-17.495-39-39-39   S305.515,231.721,305.515,253.226z M353.515,253.226c0,4.962-4.037,9-9,9s-9-4.038-9-9s4.037-9,9-9   S353.515,248.264,353.515,253.226z"
}));

function Svg213(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 506.452 506.452",
    fill: "inherit",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg213);
export default __webpack_public_path__ + "static/media/2_13.98c868fb.svg";
export { ForwardRef as ReactComponent };